import { render, staticRenderFns } from "./BlockedPayment.vue?vue&type=template&id=961d17dc"
import script from "./BlockedPayment.vue?vue&type=script&lang=js"
export * from "./BlockedPayment.vue?vue&type=script&lang=js"
import style0 from "./BlockedPayment.vue?vue&type=style&index=0&id=961d17dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports